/* import __COLOCATED_TEMPLATE__ from './create-actions-dropdown-option-component.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import templateOnlyComponent from '@ember/component/template-only';

const CreateActionsDropdownOption = templateOnlyComponent();
export default CreateActionsDropdownOption;
